import { CrudModule } from "@/command/ccCrud";

export default function Compliance() {
  return (
    <CrudModule
      title="Compliance" subtitle="Filings and renewals with due dates — feeds Compliance health."
      module="compliance" endpoint="/cc/compliance/items" entity="compliance_item" summaryPath="/cc/compliance/summary"
      columns={[["title", "Item"], ["authority", "Authority"], ["due_date", "Due"], ["status", "Status", "badge"], ["notes", "Notes"]]}
      fields={[["title", "Title", "text"], ["authority", "Authority", "text"], ["due_date", "Due date", "date"],
        ["status", "Status", "select", ["Upcoming", "Filed", "Overdue"]], ["notes", "Notes", "text"]]}
      defaults={{ status: "Upcoming" }}
      kpis={(rows, s) => [
        { label: "Total Items", value: s?.total ?? rows.length },
        { label: "Overdue", value: s?.overdue ?? 0 },
        { label: "Upcoming", value: s?.upcoming ?? 0 },
        { label: "Filed", value: s?.filed ?? 0 },
      ]}
    />
  );
}
